module.exports = __webpack_public_path__ + "static/industries-distribution-6cf6ddf834ccc8fc66a4f1cec1813ac8.png";